import 'moment/locale/pt-br'

import Table from '../../Table';
import { ColumnDescription } from 'react-bootstrap-table-next';

import SpinnerComponent from '../../Loding/Spinner';
import { useState } from 'react';
import { IContratosGerados } from '../../../Interfaces/Geral/ContratosGerados/ContratosGeradosInterface';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faEye } from '@fortawesome/free-solid-svg-icons';
import ModalComponent from '../../Modais';
import { IComponentModal } from '../../Modais/IModalComponent';
import VizualizarContratoModal from './ModalVizualizarContrato/ModalVizualizarContrato';
import { GetContratoPorCasoController } from '../../../Controllers/Geral/ContratosGerados/ContratosGeradosController';
import useAsyncEffect from '../../../hooks/useAsyncEffect';
import EditarStatusContrato from './ModalEditarStatusContrato/ModalEditarStatusContrato';

interface IContratosGeradosCardProps {
    ID_CASO: number
}

export default function ContratosGeradosCard(props: IContratosGeradosCardProps) {

    // const [lstContratos, setLstContratos] = useState<Array<IContratosGerados>>();
    const [show, setShow] = useState(false);
    const [modal, setModal] = useState<IComponentModal>();

    const {
        value: lstContratos,
        execute: updateList
    } = useAsyncEffect(async () => {
        return GetContratoPorCasoController(props.ID_CASO)
    }, [props.ID_CASO]);

    const tableViewColumns: Array<ColumnDescription<IContratosGerados>> = [{
        dataField: 'ID_CONTRATO',
        text: 'Contrato',
        headerAlign: 'center'
    }, {
        dataField: 'ID_DOCUMENTO_TEMPLATE',
        text: 'Template',
        headerAlign: 'center'
    }, {
        dataField: 'DT_CADASTRO',
        text: 'Data de Criação',
        headerAlign: 'center',
        formatter: (c) => c ? new Date(c).toLocaleString() : '-'
    }, {
        dataField: 'ID_USUARIO_RESPONSAVEL',
        text: 'Responsável',
        headerAlign: 'center'
    }, {
        dataField: 'DS_CONTRATO_STATUS',
        text: 'Status',
        headerAlign: 'center',
        formatter: (_, row) =>
            <div className="d-flex justify-content-center align-items-center g-5 ml-n10 mr-n10">
                <div>
                    <label>{row.DS_CONTRATO_STATUS}</label>
                    <button className="btn text-primary font-weight-bold mr-2 d-flex-nowrap align-items-center mb-1"
                        onClick={() => {
                            setShow(true);
                            setModal({
                                headerComponent: "Editar Status Contrato",
                                IconHeader: faEdit,
                                Component: () => <EditarStatusContrato setShow={setShow} then={updateList} Contrato={row}/>
                            });
                        }}>
                        <span>
                            <FontAwesomeIcon icon={faEdit} size={"sm"} />
                        </span>
                    </button>
                </div>
            </div>
    }, {
        dataField: 'button',
        text: '',
        isDummyField: true,
        formatter: (_, row) =>
            <div className="d-flex justify-content-center align-items-center">
                <div>
                    {
                        <button className="btn btn-info d-flex align-items-center justify-content-center flex-nowrap g-2"
                            onClick={() => {
                                setShow(true);
                                setModal({
                                    headerComponent: "Visualizar Contrato",
                                    IconHeader: faEye,
                                    size: 'xl',
                                    Component: () => <VizualizarContratoModal setShow={setShow} html={row.DS_HTML_CONTRATO} />
                                })
                            }}>
                            Visualizar
                            <span>
                                <FontAwesomeIcon icon={faEye} size={"sm"} />
                            </span>
                        </button>
                    }
                </div>
            </div>
    }];
    return (
        <div className="card card-custom w-auto gutter-b">
            {
                lstContratos ?
                    <>
                        <Table
                            data={lstContratos}
                            columns={tableViewColumns}
                            hover
                            striped
                            wrapperClasses='x-scroll'
                            defaultStyle={{
                                align: "center",
                                classes: "p-2"
                            }}
                            keyField='ID_CONTRATO'
                            bordered={false}
                            noSearch={false}
                            center
                            noHover
                            noDataIndication={() => <div className="text-black-50 text-center">Nenhum Contrato Gerado</div>}
                            paginationColor='Cobranca'
                        />
                    </>
                    :
                    <SpinnerComponent />
            }

            <ModalComponent setShow={setShow} show={show} ModalComponent={modal} />
        </div>
    )
}